import { createReducer, on } from '@ngrx/store';
import { CustomDotCmsPageContainer } from '../../models/container/custom-dot-cms-page-container.model';
import { loadDotCmsContainersSuccess } from './dotcms-container-action';

export interface DotCmsContainerState {
  [containerId: string]: CustomDotCmsPageContainer;
}

const initialState: DotCmsContainerState = {};

export const dotCmsContainerReducer = createReducer(
  initialState,
  on(loadDotCmsContainersSuccess, (state, action) => ({ ...state, ...action.payload.containers }))
);
